// Shared staff data for the employee performance section
export const STAFF_ORDER = [
    "a1b2c3d4-e5f6-7890-abcd-ef1234567890", // Sarah Miller
    "b2c3d4e5-f6a7-8901-bcde-f12345678901", // John Davis
    "c3d4e5f6-a7b8-9012-cdef-123456789012", // Emily Rose
    "d4e5f6a7-b8c9-0123-def1-234567890123", // Mike Thompson
    "e5f6a7b8-c9d0-1234-ef12-345678901234", // Lisa Wong
];

export const staffDetails: Record<string, any> = {
    "a1b2c3d4-e5f6-7890-abcd-ef1234567890": {
        employeeId: "EMP-2023-10-001",
        name: "Sarah Miller",
        role: "Lead Pharmacist",
        status: "Active",
        contact: "+971 58 120 1204",
        department: "Pharmacy",
        jobTitle: "Senior Pharmacist",
        workLocation: "Al Khawaneej",
        joiningDate: "2020-02-10",
        reportingManager: "Dr. Amin Shah",
        employmentType: "Full-Time",
        shift: "Morning",
        performance: "Excellent",
        hrNotes: "Employee of the month - July 2023",
        recentActivity: {
            name: "Sarah Johnson",
            role: "Senior Pharmacist",
            processed: 342,
            accuracy: "99.8%",
            productivity: 95,
            rating: "4.9★"
        },
        metrics: {
            weeklyData: [
                { week: "Week 1", approvals: 82, prescriptions: 70 },
                { week: "Week 2", approvals: 90, prescriptions: 75 },
                { week: "Week 3", approvals: 95, prescriptions: 80 },
                { week: "Week 4", approvals: 75, prescriptions: 60 },
            ]
        }
    },
    "b2c3d4e5-f6a7-8901-bcde-f12345678901": {
        employeeId: "EMP-2023-09-015",
        name: "John Davis",
        role: "Pharmacist",
        status: "Off",
        contact: "+971 58 234 5678",
        department: "Pharmacy",
        jobTitle: "Pharmacist",
        workLocation: "Al Khawaneej",
        joiningDate: "2021-06-15",
        reportingManager: "Sarah Miller",
        employmentType: "Full-Time",
        shift: "Afternoon",
        performance: "Good",
        hrNotes: "Completed advanced certification",
        recentActivity: {
            name: "John Davis",
            role: "Pharmacist",
            processed: 298,
            accuracy: "99.5%",
            productivity: 88,
            rating: "4.7★"
        },
        metrics: {
            weeklyData: [
                { week: "Week 1", approvals: 65, prescriptions: 58 },
                { week: "Week 2", approvals: 72, prescriptions: 65 },
                { week: "Week 3", approvals: 78, prescriptions: 70 },
                { week: "Week 4", approvals: 68, prescriptions: 62 },
            ]
        }
    },
    "c3d4e5f6-a7b8-9012-cdef-123456789012": {
        employeeId: "EMP-2023-08-022",
        name: "Emily Rose",
        role: "Pharmacist",
        status: "Active",
        contact: "+971 58 345 6789",
        department: "Pharmacy",
        jobTitle: "Pharmacist",
        workLocation: "Al Khawaneej",
        joiningDate: "2022-01-20",
        reportingManager: "Sarah Miller",
        employmentType: "Full-Time",
        shift: "Morning",
        performance: "Excellent",
        hrNotes: "High performance consistently",
        recentActivity: {
            name: "Emily Rose",
            role: "Pharmacist",
            processed: 356,
            accuracy: "99.2%",
            productivity: 92,
            rating: "4.8★"
        },
        metrics: {
            weeklyData: [
                { week: "Week 1", approvals: 88, prescriptions: 78 },
                { week: "Week 2", approvals: 85, prescriptions: 80 },
                { week: "Week 3", approvals: 92, prescriptions: 85 },
                { week: "Week 4", approvals: 80, prescriptions: 72 },
            ]
        }
    },
    "d4e5f6a7-b8c9-0123-def1-234567890123": {
        employeeId: "EMP-2023-07-033",
        name: "Mike Thompson",
        role: "Tech",
        status: "Active",
        contact: "+971 58 456 7890",
        department: "Pharmacy",
        jobTitle: "Pharmacy Technician",
        workLocation: "Al Khawaneej",
        joiningDate: "2022-09-05",
        reportingManager: "Sarah Miller",
        employmentType: "Full-Time",
        shift: "Night",
        performance: "Good",
        hrNotes: "Reliable night shift worker",
        recentActivity: {
            name: "Mike Thompson",
            role: "Pharmacy Technician",
            processed: 234,
            accuracy: "98.5%",
            productivity: 85,
            rating: "4.5★"
        },
        metrics: {
            weeklyData: [
                { week: "Week 1", approvals: 55, prescriptions: 48 },
                { week: "Week 2", approvals: 60, prescriptions: 52 },
                { week: "Week 3", approvals: 58, prescriptions: 50 },
                { week: "Week 4", approvals: 52, prescriptions: 45 },
            ]
        }
    },
    "e5f6a7b8-c9d0-1234-ef12-345678901234": {
        employeeId: "EMP-2023-06-044",
        name: "Lisa Wong",
        role: "Tech",
        status: "Break",
        contact: "+971 58 567 8901",
        department: "Pharmacy",
        jobTitle: "Pharmacy Technician",
        workLocation: "Al Khawaneej",
        joiningDate: "2023-03-12",
        reportingManager: "Sarah Miller",
        employmentType: "Full-Time",
        shift: "Afternoon",
        performance: "Good",
        hrNotes: "New team member, progressing well",
        recentActivity: {
            name: "Lisa Wong",
            role: "Pharmacy Technician",
            processed: 212,
            accuracy: "99.0%",
            productivity: 82,
            rating: "4.4★"
        },
        metrics: {
            weeklyData: [
                { week: "Week 1", approvals: 50, prescriptions: 42 },
                { week: "Week 2", approvals: 58, prescriptions: 48 },
                { week: "Week 3", approvals: 62, prescriptions: 52 },
                { week: "Week 4", approvals: 55, prescriptions: 46 },
            ]
        }
    }
};
